processPaymentMethodUpdate